export const contentfulImageLoader =
  (supportsWebp = true, proxy = false) =>
  ({ src, width }) =>
    `${src}?w=${width}${supportsWebp ? '&fm=webp' : ''}`
